import { useEffect } from "react"
import { AxiosResponse } from "axios"

import { request } from "../../request"

interface IAuthResponse {
  token_type: string
  expires_in: number
  ext_expires_in: number
  access_token: string
}

const getStockAuthToken = async (): Promise<AxiosResponse<IAuthResponse>> => {
  return request({
    url: "/api/stockToken",
    method: "post",
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
    withCredentials: true,
  })
}

export const useStockAuthToken = (
  addAuth: Function,
  handleError: (error: Error) => any
) => {
  useEffect(() => {
    getStockAuthToken()
      .then((data) => {
        addAuth(data)
      })
      .catch(handleError)
    // eslint-disable-next-line
  }, [])
}
